import { Serializable } from "models/Serializable";
import { EtiquetteInfos } from "./Grid/Etiquette/EtiquetteInfos";

export class WarehouseElementData
  implements Serializable<WarehouseElementData>
{
  type = "";
  id = "";
  etiquette!: EtiquetteInfos;
  gridElementLocationSpan!: WarehouseElementLocation[];

  deserialize(input: any): WarehouseElementData {
    this.type = input.type;
    this.id = input.id;
    this.etiquette = new EtiquetteInfos().deserialize(input.etiquette);
    this.gridElementLocationSpan = input.gridElementLocationSpan;
    return this;
  }
}

export type WarehouseElementLocation = {
  start: {
    x: number;
    y: number;
  };
  end?: {
    x: number;
    y: number;
  };
};
